import axios from "axios";
import authHeader from "@/services/auth-header";
import config from '@/data/config';

const API_URL = config.baseURL;
// const API_URL = "https://langkau.betaeo.com/service/v1/";

class APIService {
   getHeader() {
      return authHeader();
   }

   // URL
   getPDFKK() {
      return API_URL + "pdf/kk";
   }

   getPDFBaptis() {
      return API_URL + "pdf/baptis";
   }

   getPDFKomuni() {
      return API_URL + "pdf/komuni";
   }

   getPDFKrisma() {
      return API_URL + "pdf/krisma";
   }

   getPDFPerkawinan() {
      return API_URL + "pdf/perkawinan";
   }

   getPDFUmat() {
      return API_URL + "pdf/umat";
   }

   getPDFLaporanBaptis() {
      return API_URL + "pdf/laporan/baptis";
   }   
   
   getPDFLaporanIuran() {
      return API_URL + "pdf/laporan/iuran";
   }
   
   getKKZIP() {
      return API_URL + "laporan/cetak_kk";
   }

   importDataUmat() {
      return API_URL + "data_umat/import";
   }
   getUmatTemplate() {
      return API_URL + "service/template/umat";
   }

   getImage() {
      return API_URL + "uploads/produk/";
   }
   getImagePengguna(filename) {
      return API_URL + "uploads/users/" + filename;
   }
   urlImageUser(filename) {
      return API_URL + "uploads/users/" + filename;
   }

   // Konfigurasi
   getConfig() {
      return axios.get(API_URL + "config", { headers: authHeader() });
   }
   putConfig(id, data) {
      return axios.put(API_URL + "config/" + id, data, {
         headers: authHeader(),
      });
   }

   // DASHBOARD
   getHomeStatus() {
      return axios.get(API_URL + "home/status", { headers: authHeader() });
   }

   login(user) {
      return axios
         .post(API_URL + "login", {
            email: user.email,
            password: user.password,
         })
         .then((response) => {
            if (response.data.status) {
               localStorage.setItem("user", JSON.stringify(response.data));
            }
            return response.data;
         });
   }

   register(user) {
      return axios.post(API_URL + "signup", {
         username: user.username,
         email: user.email,
         password: user.password,
      });
   }
}

export default new APIService();
